// src/pages/ThankYou.js
import React from "react";
import "../styles/ThankYou.css";

const ThankYou = () => {
  return (
    <div className="thankyou-container">
      <div className="thankyou-card">
        <img src="/hotels.png" alt="Hotel Logo" className="thankyou-logo" />
        <h1>Thank You for Your Feedback!</h1>
        <p>We appreciate your time and effort in helping us improve our service.</p>
      </div>
    </div>
  );
};

export default ThankYou;
